import React from "react";
import styles from "./style.module.scss";
import WinTAXSummary from "../../../components/WinTAX/WinTAXSummary";
import ImportsDataManager from "../../../components/DataManagers/ImportsDataManager";

function WinTAXSummaryPage() {
  return (
    <div className={styles.fullscreen}>
      <ImportsDataManager />
      <WinTAXSummary />
    </div>
  );
}

export default WinTAXSummaryPage;
